import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IDownloadNovosNegociosArquivoUseCase } from "../../../presentation/useCases/read/download_novos_negocios_arquivo_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";


export class DownloadNovosNegociosArquivoUseCase implements IDownloadNovosNegociosArquivoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async downloadNovosNegociosArquivo(
    idNovosNegocios: number,
    nomeArquivo: string,
  ): Promise<void> {
    const response = await this.repository.downloadNovosNegociosArquivo(idNovosNegocios);
    if (response === null) throw new Error('Falha ao buscar dados da image!');
    await downloadBase64File(nomeArquivo, response);
  }
}
